export default __webpack_public_path__ + "static/media/hero.a60e31a1.png";